import type { CalculationBasicData } from "./sections/BasicData";
import type { Currency } from "../data/BaseEntity";
import type { PriceValue } from "../misc/price";
import dayjs from "../dayjs";

export interface CalculationDraft {
  calculationId: string | undefined;
  versionName?: string;
  basicData: CalculationBasicData;
  packageId?: string;
  currency?: Currency;
  products: {
    id: string;
    daysShift: number;
    options: {
      id: string;
      quantity: number;
      price?: PriceValue;
    }[];
  }[];
}

export type CalculationDraftProduct = CalculationDraft["products"][number];

export const emptyDraft: CalculationDraft = {
  calculationId: undefined,
  basicData: {
    name: "",
    margin: 0,
    startDate: dayjs().add(1, "day"),
    freePeopleCount: 0,
    peopleCount: 1,
    additionalInfo: "",
  },
  products: [],
};
